import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import { useResponsive } from 'src/hooks/use-responsive';

import { bgBlur } from 'src/theme/css';

import SvgColor from 'src/components/svg-color';

import { useAppSelector } from 'src/store';
import { Box } from '@mui/material';
import { NAV, HEADER } from '../../config-layout';

// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
};

export default function Header({ onOpenNav }: Props) {
  const { notification, transaction } = useAppSelector((state) => state.badge);

  const { unReadCount } = notification;
  const { redeem, topup, withdraw, position, topupDeposit, deposit, almostExpired } = transaction;

  const totalBadge =
    (unReadCount || 0) +
    (redeem || 0) +
    (topup || 0) +
    (withdraw || 0) +
    (position || 0) +
    (topupDeposit || 0) +
    (deposit || 0) +
    (almostExpired || 0);

  const theme = useTheme();

  const lgUp = useResponsive('up', 'lg');

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP_OFFSET,
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {!lgUp && (
          <IconButton onClick={onOpenNav}>
            <Box sx={{ position: 'relative' }}>
              <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
              <Box
                sx={{
                  position: 'absolute',
                  top: '-12px',
                  right: '-12px',
                  padding: '2px 6px',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#B66E00',
                  bgcolor: '#FFF2DD',
                  borderRadius: 999,
                }}
              >
                {totalBadge > 99 ? 99 : totalBadge}
              </Box>
            </Box>
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
}
